export default __webpack_public_path__ + "static/media/brush.27711fa9.cur";